import { api } from '../api/client.js';
import { useAppAuth } from '../components/AuthContext.jsx';

export default function MyAccount() {
  const { user } = useAppAuth();
  const exportData = async () => {
    try {
      const { data } = await api.get('/auth/export');
      const url = URL.createObjectURL(new Blob(
        [JSON.stringify(data, null, 2)],
        { type: 'application/json' },
      ));
      const link = document.createElement('a');
      link.href = url;
      link.download = `drill-data-${user.id}.json`;
      link.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      window.alert(error.message || 'Export dat se nepodařil.');
    }
  };

  if (!user) {
    return <section className="dashboard"><p className="dashboard__status">Načítá se…</p></section>;
  }

  const roleLabel = {
    JCH: 'JCH',
    JR: 'JR',
    Makler: 'Makléř',
  }[user.role] || user.role;

  return (
    <section className="dashboard">
      <div className="dashboard__header">
        <div>
          <h1 className="dashboard__title">Můj účet</h1>
          <p className="dashboard__lead">Správa Vašeho profilu, role a přístupových práv.</p>
        </div>
      </div>

      <div className="dashboard__cards">
        <article className="card">
          <span className="card__caption">Profil</span>
          <span className="card__big">{user.full_name || user.username || 'Uživatel'}</span>
          <span className="card__hint">{user.position || 'Bez pozice'}</span>
        </article>

        {user.role === 'Makler' && (
          <article className="card">
            <h2 className="card__title">Osobní údaje</h2>
            <p className="card__hint">
              Můžeš si stáhnout kopii údajů vedených v Drillu. O opravu nebo výmaz požádej JCH.
              Osobní údaje se po třech letech od ukončení spolupráce anonymizují.
              Sdílená kancelářská databáze kontaktů v exportu není.
            </p>
            <button className="button button--primary" type="button" onClick={exportData}>
              Stáhnout moje data
            </button>
          </article>
        )}

        <article className="card">
          <span className="card__caption">Role</span>
          <span className="card__big">{roleLabel}</span>
          <span className="card__hint">Stav: {user.status || 'active'}</span>
        </article>
      </div>

      <article className="card">
        <h2 className="card__title">Detaily účtu</h2>
        <div className="overview" role="table" aria-label="Detaily účtu">
          <div className="overview__row overview__row--head">
            <span className="overview__head">Pole</span>
            <span className="overview__head">Hodnota</span>
          </div>
          {user.role !== 'Makler' && <div className="overview__row">
            <span className="overview__cell">Uživatelské jméno</span>
            <span className="overview__cell">{user.username || '—'}</span>
          </div>}
          <div className="overview__row">
            <span className="overview__cell">E-mail</span>
            <span className="overview__cell">{user.email || '—'}</span>
          </div>
          <div className="overview__row">
            <span className="overview__cell">Celé jméno</span>
            <span className="overview__cell">{user.full_name || '—'}</span>
          </div>
          <div className="overview__row">
            <span className="overview__cell">Pozice</span>
            <span className="overview__cell">{user.position || '—'}</span>
          </div>
          <div className="overview__row">
            <span className="overview__cell">Role</span>
            <span className="overview__cell">{roleLabel}</span>
          </div>
          <div className="overview__row">
            <span className="overview__cell">Stav</span>
            <span className="overview__cell">{user.status || 'active'}</span>
          </div>
        </div>
      </article>
    </section>
  );
}
